export var CoveragesGroupingCriteria;
(function (CoveragesGroupingCriteria) {
    CoveragesGroupingCriteria["ByDebtorCountry"] = "by-debtor-country";
    CoveragesGroupingCriteria["ByInsuredCompanyCountry"] = "by-insured-company-country";
    CoveragesGroupingCriteria["ByTradeSector"] = "by-trade-sector";
    CoveragesGroupingCriteria["ByDebtorSapioRating"] = "by-debtor-sapio-rating";
    CoveragesGroupingCriteria["ByInsuranceCompany"] = "by-insurance-company";
})(CoveragesGroupingCriteria || (CoveragesGroupingCriteria = {}));
